import { larkYellow, darkGrey, primaryColor } from '~/colors'
export default {
    input: {
        display: 'flex',
        flexGrow: 1,
        marginBottom: 15,
    },
    leftInput: {
        display: 'flex',
        flexGrow: 1,
        marginRight: 15,
    },
    state: {
        display: 'flex',
        flexGrow: 1,
        marginRight: 15,
        marginBottom: 15,
        width: 100,
    },
    longInput: {
        display: 'flex',
        flexGrow: 2,
        marginRight: 15,
        marginBottom: 15,
        width: 254
    },
    row: { 
        flexWrap: 'column'
    },
    bottomRow: { 
        marginTop: 25,
        justifyContent: 'center'
    },
    zip: { width: 80 },
    fullInput: {
        display: 'flex',
        flexGrow: 1,
        marginBottom: 15,
    },
    message: {
        height: 200,
        width: '100%',
        fontFamily: 'Lato, Arial, Helvetica, sans-serif',
        color: darkGrey,
        lineHeight: '2'
    },
    label: {
        width: '50%',
        fontFamily: 'Lato, Arial, Helvetica, sans-serif',
        color: darkGrey,
        lineHeight: '2'
    },
    button: {
        borderRadius: 50
    }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Form/styles.js